export class Icons {
    public IconId: number;
    public IconName: string;
    public Icon: string;
}
